/**
 * SVG Type Detector
 */

import { SEMANTIC_TYPES } from '@/detectors/semanticTypes';
import type { ISemanticType } from '@/interfaces/ISemanticType';
import type { ITypeDetector } from '@/interfaces/ITypeDetector';

export const SvgDetector: ITypeDetector = {
  id: 'svg-detector',
  name: 'SVG Detector',
  priority: 72, // Higher than HTML/XML since SVG is more specific
  detectedType: SEMANTIC_TYPES.SVG,

  detect(input: string): ISemanticType | null {
    const trimmed = input.trim();
    
    // Must start with < (XML-like)
    if (!trimmed.startsWith('<')) {
      return null;
    }

    // Check for <svg tag
    if (/<svg[\s>]/i.test(trimmed)) {
      // Verify it's actually SVG content
      if (/<\/svg>/i.test(trimmed) || trimmed.includes('xmlns="http://www.w3.org/2000/svg"')) {
        return SEMANTIC_TYPES.SVG;
      }
      
      // Self-closing or simple SVG
      if (/<svg[^>]*\/>/i.test(trimmed)) {
        return SEMANTIC_TYPES.SVG;
      }

      // Has SVG-specific elements
      const svgElements = ['path', 'rect', 'circle', 'ellipse', 'line', 'polyline', 'polygon', 'g', 'defs', 'use'];
      for (const elem of svgElements) {
        if (new RegExp(`<${elem}[\\s>]`, 'i').test(trimmed)) {
          return SEMANTIC_TYPES.SVG;
        }
      }
    }

    return null;
  },
};
